var exports = {
  "iE": "xaf9ae18d--bc7c60--wrapper",
  "Kk": "xaf9ae18d--bc7c60--icon",
  "DD": "xaf9ae18d--bc7c60--title",
  "iU": "xaf9ae18d--bc7c60--message",
};

module.exports = exports;
